import { api, nonresidentApi } from '.'

export const shortlinkApi = nonresidentApi.injectEndpoints({
  endpoints: build => ({
    shortLinkDecode: build.mutation({
      query: ({ token }) => ({
        url: `/short-link/decode/`,
        method: 'POST',
        body: { token }
      })
    })
  })
})

export const { useShortLinkDecodeMutation } = shortlinkApi
